"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _cookieHelper = require("./cookieHelper");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var _createUUID = _interopRequireDefault(require("./createUUID"));

var _default = function _default() {
  var preferredId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var labsId = preferredId || _hubspot.default.get() || (0, _cookieHelper.getCookie)('__hstc') || (0, _createUUID.default)();
  return String(labsId);
};

exports.default = _default;
module.exports = exports.default;